export default __webpack_public_path__ + "static/sofi-d0fe04cd3e63a50f44921f0ab9607586.png";